/**
 * Consumable stack helpers — keep InventorySystem buy/use under size limits.
 */

/** Buy refuse reason when unique consumable pile is at maxStacks (SPY-507). */
export const CONSUMABLE_REFUSE_UNIQUE_MAX = 'Máximo de cargas';
/** Use refuse when potion at full HP (SPY-607). */
export const CONSUMABLE_REFUSE_FULL_HP = 'Vida al máximo';
/** Use refuse when no charges remain (SPY-707). */
export const CONSUMABLE_REFUSE_NO_CHARGES = 'Sin cargas';
/** Use refuse when owner is dead (SPY-807). */
export const CONSUMABLE_REFUSE_DEAD = 'Campeón muerto';
/** Use refuse when owner already has a heal HoT (SPY-907). */
export const CONSUMABLE_REFUSE_HEALING = 'Ya regenerando';
/** Use refuse when owner is silenced (SPY-1007). */
export const CONSUMABLE_REFUSE_SILENCED = 'Silenciado';
/** Use refuse when owner is stunned (SPY-1107). */
export const CONSUMABLE_REFUSE_STUNNED = 'Aturdido';
/** Use refuse when owner is rooted (SPY-1207). */
export const CONSUMABLE_REFUSE_ROOTED = 'Enraizado';

export function ownerHasActiveHealBuff(owner) {
  const buffs = owner?.buffs;
  if (!Array.isArray(buffs) || buffs.length === 0) return false;
  return buffs.some((b) => {
    if (!b) return false;
    if (b.isHealing || b.healAmount > 0 || b.hpRegen > 0) return true;
    const id = typeof b.id === 'string' ? b.id : '';
    return id.includes('heal') || id.includes('potion') || id.includes('regen');
  });
}

export function ownerIsSilenced(owner) {
  if (!owner) return false;
  if (owner.silenced === true) return true;
  if (owner.statusManager?.hasEffect?.('silence')) return true;
  const buffs = owner.buffs;
  if (!Array.isArray(buffs)) return false;
  return buffs.some((b) => b && (b.id === 'silence' || b.type === 'silence'));
}

export function ownerIsStunned(owner) {
  if (!owner) return false;
  if (owner.stunned === true) return true;
  if (owner.statusManager?.hasEffect?.('stun')) return true;
  const buffs = owner.buffs;
  if (!Array.isArray(buffs)) return false;
  return buffs.some((b) => b && (b.id === 'stun' || b.type === 'stun'));
}

export function ownerIsRooted(owner) {
  if (!owner) return false;
  if (owner.rooted === true) return true;
  if (owner.statusManager?.hasEffect?.('root')) return true;
  const buffs = owner.buffs;
  if (!Array.isArray(buffs)) return false;
  return buffs.some((b) => b && (b.id === 'root' || b.type === 'root'));
}

export function totalConsumableStacks(slots, itemId) {
  let n = 0;
  for (const s of slots || []) {
    if (s && s.id === itemId && s.isConsumable) n += s.stacks ?? 1;
  }
  return n;
}

export function canAddConsumableStack(slots, itemDef) {
  if (!itemDef) return false;
  const max = itemDef.maxStacks ?? 1;
  return totalConsumableStacks(slots, itemDef.id) < max;
}

export function findStackableSlot(slots, itemId) {
  return slots.findIndex((s) => {
    if (!s || s.id !== itemId || !s.isConsumable) return false;
    const max = s.maxStacks ?? 1;
    const cur = s.stacks ?? 1;
    return cur < max;
  });
}

export function createStackedSlot(itemDef) {
  return { ...itemDef, stacks: 1 };
}

export function tryIncrementStack(slot) {
  if (!slot) return false;
  const max = slot.maxStacks ?? 1;
  const cur = slot.stacks ?? 1;
  if (cur >= max) return false;
  slot.stacks = cur + 1;
  return true;
}

export function decrementStackOrClear(slots, slotIndex) {
  const item = slots[slotIndex];
  if (!item) return;
  const cur = item.stacks ?? 1;
  if (cur <= 1) {
    slots[slotIndex] = null;
    return;
  }
  item.stacks = cur - 1;
}

export function canUseConsumableAtHp(owner, itemDef) {
  if (!owner || !itemDef?.isConsumable) return true;
  if ((itemDef.stacks ?? 1) <= 0) return false;
  if (itemDef.healAmount && owner.hp >= owner.maxHp) return false;
  return true;
}

export function stackSellRefund(item) {
  if (!item) return 0;
  const stacks = Math.max(1, item.stacks ?? 1);
  return Math.floor((item.cost * 7) / 10) * stacks;
}
